import { tourFunctions } from "../tour-functions";
const { getIndex } = tourFunctions.currentScene;
const getCurrentSceneIndex = getIndex;

// Preloader.js
export class Preloader {
  constructor(tour, directions = ["u", "d", "f", "b", "l", "r"]) {
    this.tour = tour;
    this.directions = directions;
    this.preloadPromises = [];
    this.scenes = tour.scenes?.filter((scene) => !scene.hidden);
  }

  preloadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.onload = resolve;
      img.onerror = reject;
    });
  }

  async preloadImages(urls) {
    this.preloadPromises = urls.map((url) => this.preloadImage(url));

    try {
      await Promise.all(this.preloadPromises);
    } catch (error) {
      console.error("Error preloading images", error);
    }
  }

  getSceneImageUrls(scene) {
    const urls = [];
    // Thumbnail
    urls.push(scene.thumbUrl);
    // Preview Image
    urls.push(scene.previewUrl);
    // Pano Images
    scene.images.forEach((image) => {
      this.directions.forEach((direction) => {
        const url = image.url.replace("%s", direction);
        urls.push(url);
      });
    });
    return urls;
  }

  async preloadScene(sceneIndex) {
    if (sceneIndex < 0 || sceneIndex >= this.scenes.length) {
      console.error("Invalid scene index");
      return;
    }

    const scene = this.scenes[sceneIndex];
    const urls = this.getSceneImageUrls(scene);
    await this.preloadImages(urls);
  }

  async preloadFirstScene() {
    await this.preloadScene(0);
  }

  async preloadNextScene() {
    const nextSceneIndex = (getCurrentSceneIndex() + 1) % this.scenes.length;
    await this.preloadScene(nextSceneIndex);
  }

  async preloadPreviousScene() {
    const prevSceneIndex =
      (getCurrentSceneIndex() - 1 + this.scenes.length) % this.scenes.length;
    await this.preloadScene(prevSceneIndex);
  }

  getHotspotImageUrls(hotspot) {
    const urls = [];
    // Popup Image
    if (hotspot.popupImage?.url) urls.push(hotspot.popupImage.url);
    // Gallery Images
    // consider gallery images for preloading
    // if (hotspot.galleryImages?.length > 0) {
    //   hotspot.galleryImages.forEach((image) => {
    //     urls.push(image.url);
    //   });
    // }
    return urls;
  }

  async preloadHotspot(hotspot) {
    const urls = this.getHotspotImageUrls(hotspot);
    await this.preloadImages(urls);
  }

  async preloadHotspots(hotspots) {
    const allUrls = hotspots.flatMap((hotspot) =>
      this.getHotspotImageUrls(hotspot)
    );
    await this.preloadImages(allUrls);
  }

  async preloadCurrentScene() {
    const scene = this.scenes[getCurrentSceneIndex()];
    await this.preloadHotspots(scene.hotspots);
  }

  async preloadThumbnails() {
    const urls = this.scenes.map((scene) => scene.thumbUrl);
    await this.preloadImages(urls);
  }

  async initialPreload() {
    await this.preloadFirstScene();
    await this.preloadThumbnails();
  }
}
